'use client';

import type { ProviderEntry } from '@lib/analytics/cookie-registry';
import Toggle from '@modules/common/components/toggle';
import { useState } from 'react';
import CategoryHeader from './category-header';
import ProviderRow from './provider-row';

type CategoryRowProps = {
  label: string;
  description: string;
  checked: boolean;
  onChange?: (checked: boolean) => void;
  alwaysActive?: boolean;
  providers?: ProviderEntry[];
};

const CategoryRow = ({
  label,
  description,
  checked,
  onChange,
  alwaysActive,
  providers = [],
}: CategoryRowProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const cookieCount = providers.reduce((sum, p) => sum + p.cookies.length, 0);
  const hasProviders = providers.length > 0;

  return (
    <div className="rounded-lg border border-brand-neutral-100 bg-white overflow-hidden">
      <div className="flex items-center justify-between px-4 py-3 gap-3">
        <CategoryHeader
          label={label}
          cookieCount={cookieCount}
          hasProviders={hasProviders}
          isExpanded={isExpanded}
          onToggle={() => setIsExpanded((v) => !v)}
        />
        <Toggle
          checked={checked}
          onChange={onChange ?? (() => {})}
          disabled={alwaysActive}
          aria-label={`Toggle ${label}`}
        />
      </div>
      <div className="border-t border-brand-neutral-100 px-4 py-3">
        <p className="font-body text-sm leading-[1.5] text-brand-neutral-900">
          {description}
        </p>
      </div>
      {isExpanded && hasProviders && (
        <div className="border-t border-brand-neutral-100 px-4 py-3">
          <div className="flex flex-col gap-4">
            {providers.map((provider) => (
              <ProviderRow key={provider.domain} provider={provider} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default CategoryRow;
